module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlayers),
      expression: "selectedPlayers"
    }],
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPlayers = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orderedPlayers), function(player, index) {
    return _c('option', {
      key: player.id,
      domProps: {
        "value": player.id
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(player.name) + "\n\t\t")])
  })), _vm._v(" "), _c('input', {
    attrs: {
      "type": "",
      "name": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedPlayers
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4169f6c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 30
// module chunks = 0